import type { AppDisplayModeType } from '@archipro-design/aria';

export * from './api';

export type CategoryTypes = 'products' | 'professionals' | 'projects';

type CategoryColumn = 1 | 2 | 3 | 4;

const CATEGORY_GRID_COLUMNS_DESKTOP: Record<CategoryTypes, CategoryColumn> = {
    products: 4,
    projects: 3,
    professionals: 3,
};

const CATEGORY_GRID_COLUMNS_MOBILE: Record<CategoryTypes, CategoryColumn> = {
    products: 2,
    projects: 1,
    professionals: 1,
};

export const getCategoryGridColumns = (
    categoryType: CategoryTypes,
    appDisplayMode: AppDisplayModeType,
): CategoryColumn => {
    const columnConfigs = appDisplayMode.mobile
        ? CATEGORY_GRID_COLUMNS_MOBILE
        : CATEGORY_GRID_COLUMNS_DESKTOP;
    return columnConfigs[categoryType];
};
